import { Spinner } from '@frontend/components/common';
import { useBrandingRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import { VERSION_NUMBER } from '../../../version';
import useProvision from './provision.controller';

export const ID = 'provision';

export enum ProvisionState {
    INIT,
    GATHERING_INFO,
    GATHERING_INFO_FAILED,
    AUTHENTICATING,
    AUTHENTICATING_FAILED,
    PERMISSION_CHECK,
    PERMISSION_CHECK_FAILED,
    DONE
}

export interface Props {
    provisionDone?: () => void;
}

const Provision = (props: Props) => {
    const viewProps = useProvision(props);
    const { logo_navbar_collapsed } = useBrandingRepository();

    return (
        <div
            id={ID}
            className='bg-always-black inline-flex h-full w-full flex-col items-center justify-start gap-10 overflow-hidden p-8'>
            <img
                src={logo_navbar_collapsed}
                className='h-14 self-center'
                alt='logo_navbar_collapsed'
            />

            <div className='flex flex-1 flex-col items-center justify-start gap-6 self-stretch'>
                <div className='text-always-white justify-start text-center text-3xl font-semibold'>Welcome, the kiosk is being provisioned</div>
                <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                    <h4 className='text-always-white justify-start self-stretch text-center text-xl font-semibold'>{viewProps.message}</h4>
                    <div className='text-always-white self-center pt-5 text-sm font-semibold'>
                        {![ProvisionState.AUTHENTICATING_FAILED, ProvisionState.GATHERING_INFO_FAILED, ProvisionState.PERMISSION_CHECK_FAILED].includes(
                            viewProps.state
                        ) ? (
                            <Spinner className='text-border-default fill-brand-primary size-8' />
                        ) : (
                            <RetryCounter />
                        )}
                    </div>
                </div>
            </div>
            <span className='text-always-white/40 text-xs font-light'>{VERSION_NUMBER}</span>
        </div>
    );
};

export default Provision;

const RetryCounter = () => {
    const [count, setCount] = useState(60);

    useEffect(() => {
        if (count !== 60) {
            setCount(60);
        }

        const interval = setInterval(() => {
            setCount((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    return 60; // Reset to 60 seconds
                }
                return prevCount - 1;
            });
        }, 1000);

        return () => {
            clearInterval(interval);
            setCount(60); // Reset count when component unmounts
        };
    }, []);

    return (
        <div className='text-always-white text-sm font-normal'>
            Trying again in <span className='font-bold'>{count}</span> seconds...
        </div>
    );
};
